export const frontmatter = {
    "draft": false,
    "title": "Analytics dashboard",
    "description": "Analytics dashboard and reports in OnnIA.",
    "sidebar_label": "Overview",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = []